export default "__VITE_ASSET__BC1OsfiZ__"